import { TableRow, TableCell, Checkbox } from '@occc/ui-design-system';
import { RetailerNetworkLocationDataFragment } from '@occc/graphql';

type RetailerNetworkUserDetailsLocationsTableRowProps = {
  location: RetailerNetworkLocationDataFragment;
  isItemSelected: boolean;
  handleItemSelect: (id: string) => void;
};

export const RetailerNetworkUserDetailsLocationsTableRow = ({
  location,
  isItemSelected,
  handleItemSelect,
}: RetailerNetworkUserDetailsLocationsTableRowProps) => {
  const locationCity = location?.address?.city || '';
  const locationState = location?.address?.state || '';
  const locationStreet = location?.address?.street1 || '';
  const locationZip = location?.address?.zipCode || '';
  const siteId = location?.siteSystemConfiguration?.[0]?.identifier || '';
  const siteName = location.name || '';
  const sitePhoneNumber = location?.phoneNumbers?.[0]?.phoneNumber || '';

  return (
    <TableRow key={location.uuid} selected={isItemSelected}>
      <TableCell padding='checkbox'>
        <Checkbox
          checked={isItemSelected}
          onClick={(event) => {
            event.stopPropagation();
            handleItemSelect(location.uuid);
          }}
        />
      </TableCell>
      <TableCell>{siteId}</TableCell>
      <TableCell>{siteName}</TableCell>
      <TableCell>
        {locationStreet}
        <br />
        {`${locationCity}, ${locationState} ${locationZip}`}
      </TableCell>
      <TableCell>{sitePhoneNumber}</TableCell>
    </TableRow>
  );
};
